<div [hidden]="!showReport" style="position: absolute; left: 0; top: 0; width: 100%; height: 100%; z-index: 1000;">
  <app-powerbi-report-embed></app-powerbi-report-embed>
</div>
<ng-container *ngIf="isInvalid">Cannot Display: Error Code 100</ng-container>
<ng-container *ngIf="isExpired">Cannot Display: Error Code 200</ng-container>
